import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import {
  ValueAddedServiceActionTypes,
  ValueAddedServiceActions,
} from "../../../actionTypes/master/valueAddedServiceActionTypes";
import { setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  getValueAddedServicesApi,
  updateValueAddedServicesApi,
} from "../../requests/master/valueAddedServiceRequests";
import {
  getValueAddedServiceList,
  setValueAddedServiceList,
} from "../../../actions/master/valueAddedServiceActions";

function* getValueAddedServiceListHandler(action: ValueAddedServiceActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getValueAddedServicesApi, action.payload);

    if (data.status) {
      yield put(setValueAddedServiceList(data?.data?.rows ?? []));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editValueAddedServicesHandler(action: ValueAddedServiceActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(updateValueAddedServicesApi, action.payload);

    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getValueAddedServiceList());
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* valueAddedServiceSaga() {
  yield takeLatest(ValueAddedServiceActions.GET_VALUE_ADDED_SERVICE_LIST, getValueAddedServiceListHandler);
  yield takeLatest(ValueAddedServiceActions.EDIT_VALUE_ADDED_SERVICES, editValueAddedServicesHandler);
}
